import React, { useEffect, useState, Suspense, lazy } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { initMetaPixel, trackPageView } from './utils/metaPixel';
import { loadFonts } from './utils/loadFonts';
// Below-the-fold sections are lazy-loaded so they do not block first paint.
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const Solution = lazy(() => import('./components/Solution').then(m => ({
  default: m.Solution
})));
const Bundle = lazy(() => import('./components/Bundle').then(m => ({
  default: m.Bundle
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const StickyCTA = lazy(() => import('./components/StickyCTA').then(m => ({
  default: m.StickyCTA
})));
const RecentPurchase = lazy(() => import('./components/RecentPurchase').then(m => ({
  default: m.RecentPurchase
})));
export function App() {
  // Mount below-the-fold sections only AFTER first paint to keep Speed Index minimal.
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    // Inject Google Fonts asynchronously (non render-blocking).
    loadFonts();
    // Mount the rest of the page on the next frame, after the hero has painted.
    const raf = requestAnimationFrame(() => setHydrated(true));
    // Defer Meta Pixel until the browser is idle.
    const win = window as any;
    const start = () => {
      initMetaPixel();
      trackPageView();
    };
    let timer: ReturnType<typeof setTimeout> | undefined;
    let idleHandle: number | undefined;
    if (typeof win.requestIdleCallback === 'function') {
      idleHandle = win.requestIdleCallback(start, {
        timeout: 3000
      });
    } else {
      timer = setTimeout(start, 2500);
    }
    return () => {
      cancelAnimationFrame(raf);
      if (timer) clearTimeout(timer);
      if (idleHandle && typeof win.cancelIdleCallback === 'function') {
        win.cancelIdleCallback(idleHandle);
      }
    };
  }, []);
  return <div className="min-h-screen bg-cream selection:bg-sand/30 selection:text-ink" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        {hydrated && <Suspense fallback={null} data-id="element-4">
            <SocialProof data-id="element-5" />
            <PainPoints data-id="element-6" />
            <Solution data-id="element-7" />
            <Bundle data-id="element-8" />
            <Testimonials data-id="element-9" />
            <FAQ data-id="element-10" />
          </Suspense>}
      </main>
      {hydrated && <Suspense fallback={null} data-id="element-11">
          <Footer data-id="element-12" />
          <StickyCTA data-id="element-13" />
          <RecentPurchase data-id="element-14" />
        </Suspense>}
    </div>;
}